import { render, staticRenderFns } from "./ComplaintDetial.vue?vue&type=template&id=8608c9bc&"
import script from "./ComplaintDetial.vue?vue&type=script&lang=js&"
export * from "./ComplaintDetial.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintDetial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports